import PropTypes from "prop-types";
import React, { Component } from "react";
import MSection, { UNMOUNT_STATUS_ALLOW, UNMOUNT_STATUS_WARNING, UNMOUNT_STATUS_DISALLOW } from "components/Shared/MSection.tsx";
import { Button } from "react-md";
import MDialog from "components/Shared/MDialog.tsx";
import { MSpinner } from "components/Shared";
import CMSHelpIcon from "components/CMS/CMSHelpIcon.tsx";

export const MSECTION_MODE_SECTION = "MSECTION_MODE_SECTION";
export const MSECTION_MODE_TAB = "MSECTION_MODE_TAB";

export const ACTION_SPLIT = "ACTION_SPLIT";
export const ACTION_SPLIT_LEFT = "ACTION_SPLIT_LEFT";
export const ACTION_CLOSE = "ACTION_CLOSE";

class MSectionCollection extends Component {
  constructor(props) {
    super(props);

    this.controlMethods = [];
    this.titleElement = null;
    this.unmountOkAction = null;

    this.setControlMethods = this.setControlMethods.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.switchDisplayMode = this.switchDisplayMode.bind(this);
    this.onTabChanged = this.onTabChanged.bind(this);
    this.titleDivResizeListenerRef = this.titleDivResizeListenerRef.bind(this);
    this.tabToolTipRef = this.tabToolTipRef.bind(this);
    this.scrollTitleElement = this.scrollTitleElement.bind(this);
    this.titleResizeObserver = this.titleResizeObserver.bind(this);
    this.scrollToTabIndex = this.scrollToTabIndex.bind(this);
    this.getSelectedTabIndex = this.getSelectedTabIndex.bind(this);
    this.getSelectedTab = this.getSelectedTab.bind(this);
    this.getAction = this.getAction.bind(this);
    this.getActions = this.getActions.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.getTitleScrollOffsets = this.getTitleScrollOffsets.bind(this);
    this.switchToTabId = this.switchToTabId.bind(this);

    this.state = {
      displayMode: props.defaultMode,
      selectedTabIndex: 0,
      showTitleScrollArrows: false,
      visitedTabs: new Array(1).fill(true),
      showUnmountDialog: false,
      unmountDialogMessage: null,
      unmountChildStatus: null,
    };
  }

  componentDidMount() {
    if (this.props.getControlMethods) {
      this.props.getControlMethods({
        toggleExpanded: this.toggleExpanded,
        switchTab: this.onTabChanged,
        switchToTabId: this.switchToTabId,
        switchMode: this.switchDisplayMode,
        getSelectedTabIndex: this.getSelectedTabIndex,
        getSelectedTab: this.getSelectedTab,
      });
    }
    if (this.props.initialTab) {
      this.switchToTabId(this.props.initialTab, true);
    }
  }

  getSelectedTabIndex() {
    return this.state.selectedTabIndex < this.props.sections.length ? this.state.selectedTabIndex : 0;
  }

  getSelectedTab() {
    return this.props.sections[this.getSelectedTabIndex()];
  }

  toggleExpanded(i, expanded) {
    if (this.controlMethods[i]) this.controlMethods[i].toggleExpanded(expanded);
  }

  setControlMethods(i, cm) {
    this.controlMethods[i] = cm;
  }

  switchDisplayMode(mode, i, forceChange) {
    let canUnmountStatus = UNMOUNT_STATUS_ALLOW;
    let canUnmountWarning;
    let unmountCallbacks = [];

    if (this.state.displayMode === MSECTION_MODE_TAB) {
      let selectedTab = this.getSelectedTab();
      // Check for selectedTab.canUnmountChildStatus so if its unspecified we dont block the user from switching tabs
      if (selectedTab.canUnmountChildStatus) {
        canUnmountStatus = selectedTab.canUnmountChildStatus;
        canUnmountWarning = selectedTab.canUnmountChildWarning;
        if (selectedTab.onChildUnmount) unmountCallbacks.push(selectedTab.onChildUnmount);
      }
    } else {
      let sections = [];
      this.props.sections.forEach((section, i) => {
        let cm = this.controlMethods[i];
        if (cm.isExpanded()) {
          // Slightly weird logic to make sure that we take the more important status
          if (section.canUnmountChildStatus === UNMOUNT_STATUS_DISALLOW) canUnmountStatus = UNMOUNT_STATUS_DISALLOW;
          if (section.canUnmountChildStatus === UNMOUNT_STATUS_WARNING && canUnmountStatus !== UNMOUNT_STATUS_DISALLOW) canUnmountStatus = UNMOUNT_STATUS_WARNING;

          // Check for section.canUnmountChildStatus first so unspecified statuses dont push
          if (section.canUnmountChildStatus && section.canUnmountChildStatus !== UNMOUNT_STATUS_ALLOW) {
            sections.push(section);
            if (section.onChildUnmount) unmountCallbacks.push(section.onChildUnmount);
          }
        }
      });

      canUnmountWarning = sections.map((s, j) => <div key={j}>{`Warning from: ${s.title}`}<br />{s.canUnmountChildWarning}<br /><br /></div>);
    }

    if (!forceChange && canUnmountStatus !== UNMOUNT_STATUS_ALLOW) {
      this.setState({
        showUnmountDialog: true,
        unmountDialogMessage: canUnmountWarning,
        unmountChildStatus: canUnmountStatus
      });
      this.unmountOkAction = () => {
        this.switchDisplayMode(mode, i, true);
        unmountCallbacks.forEach(uc => uc());
      };
    } else {

      let newState = { displayMode: mode };

      if (mode === MSECTION_MODE_SECTION) newState.showTitleScrollArrows = false;

      if (i === undefined && mode === MSECTION_MODE_TAB) {
        newState.selectedTabIndex = 0;
      } else {
        newState.selectedTabIndex = i;
      }

      this.setState(newState);
    }
  }

  getTitleScrollOffsets() {
    let outerWidth = (el) => {
      let style = getComputedStyle(el);
      return el.offsetWidth + parseInt(style.marginLeft) + parseInt(style.marginRight);
    };

    let titleScrollOffsets = [];

    if (this.state.showTitleScrollArrows) {
      titleScrollOffsets[0] = 0;

      [...this.titleElement.children].forEach((div, i) => {
        titleScrollOffsets[i + 1] = titleScrollOffsets[i] + outerWidth(div);
      }, 0);
    } else {
      titleScrollOffsets = null;
    }

    return titleScrollOffsets;
  }

  titleResizeObserver() {
    if (!this.titleElement) return;

    let showTitleScrollArrows = this.titleElement.scrollWidth > this.titleElement.clientWidth;
    if (showTitleScrollArrows != this.state.showTitleScrollArrows) {
      // Dont scroll until after this state update
      this.setState({ showTitleScrollArrows: showTitleScrollArrows }, this.scrollToTabIndex);
    } else {
      this.scrollToTabIndex();
    }
  }

  tabToolTipRef(element) {
    if (element) {
      // Sadly i have to set a timeout here because if it happens immediately the scroll width will never be larger because the component has not sized properly yet
      setTimeout(() => {
        if (element.scrollWidth > element.clientWidth) element.title = element.innerText;
      }, 1000);
    }
  }

  titleDivResizeListenerRef(element) {
    this.titleElement = element;
    if (element) {
      new ResizeObserver(this.titleResizeObserver).observe(element);
    }
  }

  scrollToTabIndex() {
    if (this.getTitleScrollOffsets() && this.titleElement) {
      this.titleElement.scrollLeft = this.getTitleScrollOffsets()[this.getSelectedTabIndex()];
    }
  }

  scrollTitleElement(direction) {
    let selectedTabIndex = this.getSelectedTabIndex() + direction;
    if (selectedTabIndex < 0 || selectedTabIndex === this.props.sections.length) return;
    this.onTabChanged(selectedTabIndex);
  }

  getAction(a) {
    let action = a;

    if (typeof a === "string") action = { code: a };

    let actionDefaults;
    switch (action.code) {
      case ACTION_SPLIT:
        actionDefaults = {
          icon: "last_page",
          order: 9700,
          helpText: "Move current tab to right pane"
        };
        break;
      case ACTION_SPLIT_LEFT:
        actionDefaults = {
          icon: "first_page",
          order: 9800,
          helpText: "Move current tab to left pane"
        };
        break;
      case ACTION_CLOSE:
        actionDefaults = {
          icon: "close",
          order: 9900,
        };
        break;
      default:
        actionDefaults = {};
        break;
    }

    return { ...actionDefaults, ...action };
  }

  getActions(sectionIndex) {
    let actions = [];
    if (this.props.actions) actions.push(...this.props.actions);
    if (this.props.sections[sectionIndex].actions) actions.push(...this.props.sections[sectionIndex].actions);

    if (actions.length === 0) return null;
    return actions.sort((a, b) => a.order > b.order ? 1 : -1).map((a, i) => {
      let action = this.getAction(a);
      return (<Button
        key={`action${i}`}
        style={{ float: "right" }}
        icon
        onClick={(event) => { event.stopPropagation(); action.onClick(sectionIndex); }}
        title={action.helpText}
      >
        {action.icon}
      </Button>);
    });
  }

  getTitleWithIcon(title, tooltip, onClick, sectionIndex) {
    let getScrollArrow = (dir) => (<i
      className="md-icon material-icons msection-scroll-arrow"
      title={`Scroll ${dir === 1 ? "Right" : "Left"}`}
      onClick={(e) => { e.stopPropagation(); this.scrollTitleElement(dir); }}>
      {`keyboard_arrow_${dir === 1 ? "right" : "left"}`}
    </i>);

    let actions = this.getActions(sectionIndex);

    return (<div className="msectioncollection-title md-full-width">
      {!this.props.disableModeChanging && <i className={`md-icon material-icons msection-collapse ${this.state.displayMode === MSECTION_MODE_SECTION ? "rotated-90-icon" : ""}`} title={tooltip} onClick={onClick}>view_headline</i>}
      {this.state.showTitleScrollArrows && getScrollArrow(-1)}
      {title}
      {this.state.showTitleScrollArrows && getScrollArrow(1)}
      {actions && <div className={"md-cell--right toolbar"}>{actions}</div>}
    </div>);
  }

  switchToTabId(id, forceChange) {
    let index = this.props.sections.findIndex(s => s.id === id);
    if (index > -1) this.onTabChanged(index, forceChange);
  }

  onTabChanged(i, forceChange) {
    if (this.state.displayMode !== MSECTION_MODE_TAB || i === this.state.selectedTabIndex) return;

    let currentTab = this.getSelectedTab();
    // Check for currentTab.canUnmountChildStatus not being undefined because if it was not specified we were blocking tab switching which was bad
    if (!(forceChange || this.props.persistTabs) && currentTab.canUnmountChildStatus && currentTab.canUnmountChildStatus != UNMOUNT_STATUS_ALLOW) {
      this.setState({
        showUnmountDialog: true,
        unmountDialogMessage: currentTab.canUnmountChildWarning,
        unmountChildStatus: currentTab.canUnmountChildStatus
      });
      this.unmountOkAction = () => {
        this.onTabChanged(i, true);
        if (currentTab.onChildUnmount) currentTab.onChildUnmount();
      };
    } else {
      let tempTabs = [];
      if (this.state.visitedTabs.length !== this.props.sections.length) {
        tempTabs = new Array(this.props.sections.length).fill(false);
        tempTabs[this.getSelectedTabIndex()] = true;
        tempTabs[i] = true;
        this.setState({ visitedTabs: tempTabs });
      } else {
        tempTabs = [...this.state.visitedTabs];
        tempTabs[i] = true;
      }
      this.setState({ selectedTabIndex: i, visitedTabs: tempTabs }, this.scrollToTabIndex);
      if (this.props.onTabChange) this.props.onTabChange(i);
    }
  }

  showDialog(show) {
    if (show === undefined) show = true;
    this.setState({ showUnmountDialog: show });
  }

  getDialogButtons() {
    if (this.state.unmountChildStatus === UNMOUNT_STATUS_WARNING) {
      return [
        <Button key="yes" primary raised onClick={() => { this.showDialog(false); this.unmountOkAction(); }}>Yes</Button>,
        <Button key="no" primary raised onClick={() => this.showDialog(false)}>No</Button>
      ];
    } else {
      return [<Button key="ok" primary raised onClick={() => this.showDialog(false)}>Ok</Button>];
    }
  }

  render() {
    if(!this.props.sections?.length) {
      return (
      <>
        <MSpinner />     
        <div className="centerText">
          <h2>Not available, please refresh</h2>
          {this.props.refresh ? <Button key="refresh" primary raised onClick={() => this.props.refresh()}>Refresh</Button> : null}      
        </div>
      </>
    );}

    let msection = null;
    if (this.state.displayMode === MSECTION_MODE_SECTION) {
      msection = this.props.sections.map((s, i) =>
        (<MSection
          key={`section${i}`}
          {...s.className && { className: s.className }}
          title={this.getTitleWithIcon(s.title, "Collapse", (e) => { e.stopPropagation(); this.switchDisplayMode(MSECTION_MODE_TAB, i); }, i)}
          defaultExpanded={s.defaultExpanded}
          collapsible={s.collapsible}
          children={s.children}
          getControlMethods={(cm) => this.setControlMethods(i, cm)}
          canUnmountChildWarning={s.canUnmountChildWarning}
          canUnmountChildStatus={s.canUnmountChildStatus}
          onChildUnmount={s.onChildUnmount}
        />));
    } else {
      let tabs = (<div className="msectioncollection-tabs" ref={this.titleDivResizeListenerRef}>
        {this.props.sections.map((s, i) =>
          <div
            ref={this.tabToolTipRef}
            key={`sectionTab${i}`}
            className={this.getSelectedTabIndex() === i ? "selected-tab" : ""}
            onClick={(e) => { e.stopPropagation(); this.onTabChanged(i); }}>
            <span className="tab-text">{s.shortTitle || s.title}</span>
            {s.cmsTopicKey && <span className="tab-icon"><CMSHelpIcon topicKey={s.cmsTopicKey} /></span>}
          </div>)}
      </div>);
      this.props.persistTabs
        ? msection = this.props.sections.map((s, i) =>
          (<MSection
            key={`section${i}`}
            visible={this.getSelectedTabIndex() === i}
            visited={(this.state.visitedTabs.length - 1) >= i && this.state.visitedTabs[i]}
            titleClassName={`msection-tabbed-title ${this.props.tabModeCollapsible ? "" : "not-collapsible"}`}
            className={`msection-tabbed ${this.props.innerSection ? "msection-inner" : ""}`}
            title={this.getTitleWithIcon(tabs, "Expand", (e) => { e.stopPropagation(); this.switchDisplayMode(MSECTION_MODE_SECTION); }, i)}
            children={this.props.sections[i].children}
            collapsible={this.props.tabModeCollapsible}
            fullHeight={this.props.fullHeight}
          />)
        )
        : msection =
        (<MSection
          titleClassName={`msection-tabbed-title ${this.props.tabModeCollapsible ? "" : "not-collapsible"}`}
          className={`msection-tabbed ${this.props.innerSection ? "msection-inner" : ""}`}
          title={this.getTitleWithIcon(tabs, "Expand", (e) => { e.stopPropagation(); this.switchDisplayMode(MSECTION_MODE_SECTION); }, this.getSelectedTabIndex())}
          children={this.props.sections[this.getSelectedTabIndex()].children}
          collapsible={this.props.tabModeCollapsible}
          fullHeight={this.props.fullHeight}
        />);
    }

    return (<>
      {this.state.showUnmountDialog && (
        <MDialog ariaLabel={"Confirm Close Tab"} contentActions={this.getDialogButtons()}>
          {this.state.unmountDialogMessage}
        </MDialog>)}
      {msection}
    </>);
  }
}

MSectionCollection.propTypes = {
  /* [{
    className, optional - class name that will be appended onto the card
    title, title that displays on the collapsible pane
    shortTitle, optional - shortened title that displays when tab mode is used
    children, content to display inside of the collapsible pane
    defaultExpanded, optional - if true the pane will be expanded on mount, if false it will not be expanded
    collapsible, optional - if false the component will not be collapsible
    canUnmountChildWarning, optional -  for the canUnmountChildStatus logic below
    canUnmountChildStatus, optional - one of UNMOUNT_STATUS_ALLOW, UNMOUNT_STATUS_DISALLOW, UNMOUNT_STATUS_WARNING
                        there are multiple ways a component can be unmounted in MSectionCollection
                        switching tabs, collapsing msection collection, switching to section view, switching to tab view, collapsing a section
                        if UNMOUNT_STATUS_ALLOW is the default if nothing is specified and the user will be able to navigate away from the child component
                        if UNMOUNT_STATUS_DISALLOW the unmount action simply will not happen. a dialog with canUnmountChildStatus will be rendered if specified
                        if UNMOUNT_STATUS_WARNING the user will be presented with the option to still navigate away. the canUnmountChildStatus message will be displayed
    onChildUnmount, optional - called when the child is unmounted
    cmsTopicKey, optional - help topic key for the section
  }, ...] */
  sections: PropTypes.array.isRequired,
  innerSection: PropTypes.bool,
  defaultMode: PropTypes.string, // If provided the control will start in this mode
  disableModeChanging: PropTypes.bool, // If true the user will not be able to switch control modes
  tabModeCollapsible: PropTypes.bool, // Defaults to true, if false the collapse button will be disabled/invisible on tab mode
  /* this callback function will be called with an object that has multiple functions on it that let you control MSection
  {
    toggleExpanded(index, expanded), expands or collapses by index, if expanded is not provided this will just toggle, otherwise if true is passed it will expand, if false is passed it will collapse
    switchTab(index), switches to tab by index
    switchMode(mode, i), switches to tab mode, either MSECTION_MODE_SECTION or MSECTION_MODE_TAB, provide the index of what tab to select if switching to MSECTION_MODE_TAB
    getSelectedTabIndex(), gets the tab that is currently selcted
  } */
  getControlMethods: PropTypes.func,
  onTabChange: PropTypes.func, // Called with the index that the tab was changed to
  fullHeight: PropTypes.bool, // will make the tabbed section render 100% height of its container and its contents will scroll
  actions: PropTypes.array, // Use this if you want custom icons in the Header //{code, icon, helpText, onClick - selected tab index or section index is passed in on click, order}
  persistTabs: PropTypes.bool, // Indicator on whether or not this instance of MSectionCollection should persist MSection tabs once viewed
  initialTab: PropTypes.string,
  refresh: PropTypes.func,
};

MSectionCollection.defaultProps = {
  defaultMode: MSECTION_MODE_SECTION,
  disableModeChanging: false,
  tabModeCollapsible: true,
  fullHeight: false,
  persistTabs: false,
};

export default MSectionCollection;